import { render, staticRenderFns } from "./BottomSection.vue?vue&type=template&id=41c0cabe&scoped=true&"
import script from "./BottomSection.vue?vue&type=script&lang=js&"
export * from "./BottomSection.vue?vue&type=script&lang=js&"
import style0 from "./BottomSection.vue?vue&type=style&index=0&id=41c0cabe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c0cabe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
